import {Component, Input, ViewChild, ElementRef, AfterViewChecked, AfterViewInit} from '@angular/core';

@Component({
    selector: 'wait-image',
    templateUrl: './wait-image.component.html'
})
export class WaitImageComponent implements AfterViewChecked, AfterViewInit{

    private isVisible: boolean;

    @Input()
    private set show(value: boolean){
        this.isVisible = value;
        if (!value){
            this.initialFocusSet = false;
        } else{
            if (!this.mainWrp){
                return
            }

            this.setClass();
        }
    }

    private get show(): boolean{
        return this.isVisible;
    }

    @Input()
    private cssClass: string;

    @Input()
    private text?: string;

    @Input()
    private notChangeFocus?: boolean;

    @ViewChild('img')
    private imgRef: ElementRef;

    @ViewChild('mainWrp')
    private mainWrp: ElementRef;

    private initialFocusSet: boolean;
    private class: string;

    //# set focus to image
    private setFocusToImg = (): void =>{
        if (this.imgRef && !this.notChangeFocus)
            this.imgRef.nativeElement.focus();
    }

    //# if need show text, set size of text, which depends on dimensions
    private setClass = (): void =>{
        if (!this.text){
            return;
        }
        let timeOut = setTimeout(() =>{
            clearTimeout(timeOut);
            timeOut = null;

            let width = this.mainWrp.nativeElement.offsetWidth,
                height = this.mainWrp.nativeElement.offsetHeight,
                cl = 'loading-text ';

            console.log(width, 'width', height, 'height')

            if ((width < 600 && height < 1000)){
                cl += 'small ';
            } else if ((width < 850 && height < 600) || (width < 2000 && height < 600)){
                cl += 'medium ';
            } else if (width < 2000 && height > 600){
                cl += 'big ';
            } else{
                cl += 'small ';
            }

            console.log(cl, 'class')

            this.class = cl;
        }, 20)

    }


    ngAfterViewChecked(): void{
        if (this.initialFocusSet)
            return;

        this.setFocusToImg();
        this.initialFocusSet = true;
    }

    ngAfterViewInit(): void{
        this.setClass();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/wait-image.component/wait-image.component.ts